<template>
  <div class="account-status">
    <div class="title-header">
      <p>CREDIT ACCOUNT STATUS</p>
    </div>
    <div class="title-header">
      <p>
        Balance: <span>{{ credit }}</span> credits
      </p>
    </div>
    <div class="title-header">
      <p>
        Transactions
        <span>
          <button type="button" class="btn btn-secondary print-btn">
            PRINT
          </button>
          <button
            class="btn dropdown-toggle dropdown-btn"
            type="button"
            data-toggle="dropdown"
            style="margin-left: 50%"
          >
            All Status 
          </button>
          <ul class="dropdown-menu">
            <li><a href="#">HTML</a></li>
            <li><a href="#">CSS</a></li>
            <li><a href="#">JavaScript</a></li>
          </ul>
          <button
            class="btn dropdown-toggle dropdown-btn"
            type="button"
            data-toggle="dropdown"
          >
            USD <span class="caret"></span>
          </button>
          <ul class="dropdown-menu">
            <li><a href="#">HTML</a></li>
            <li><a href="#">CSS</a></li>
            <li><a href="#">JavaScript</a></li>
          </ul>
        </span>
      </p>
    </div>
    <div class="table-data">
      <table class="table table-borderless">
        <thead>
          <tr>
            <th style="text-decoration: underline">Date</th>
            <th style="text-decoration: underline">Item</th>
            <th style="text-decoration: underline">Status</th>
            <th style="text-decoration: underline">Amount paid</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="data in statusData" :key="data">
            <td>{{ data.datetime }}</td>
            <td>{{ data.item }}</td>
            <td>{{ data.status }}</td>
            <td>{{ data.paid }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "account-status",
  data() {
    return {
      credit: 0,
      statusData: [
        {
          datetime: "03/05/2020 16.16",
          item: "Voucher posting",
          status: "used",
          paid: "1.34",
        },
        {
          datetime: "03/05/2020 16.16",
          item: "Voucher posting",
          status: "used",
          paid: "224",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.account-status {
  .title-header {
    color: #58595b;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 40px;
  }
  .select-btn {
    font-size: 14px;
  }
  .print-btn {
    background-color: #b9b9b9;
    border: none;
    border-radius: 4px;
    margin-left: 2%;
  }
  .table-data {
    font-size: 14px;
  }
  .dropdown-btn {
    color: #58595b;
    border-color: #fff transparent transparent transparent;
    background-color: transparent;
    font-size: 14px;
  }
}
</style>